import { gql } from '@apollo/client';

export const fragments = {
  all: gql`
    fragment ProcedureStepData on ProcedureStep {
      id
      name
      type
      order
      options
      timestamp(patientId: $patientId)
    }
  `,
};

export const orTabletProcedureSteps = gql`
  query ($patientId: Long) {
    orTabletProcedureSteps(patientId: $patientId) {
      ...ProcedureStepData
      measurement(patientId: $patientId) {
        id
        timestamp
      }
    }
  }
  ${fragments.all}
`;

export const procedureSteps = gql`
  query ($patientId: Long) {
    procedureSteps(patientId: $patientId) {
      ...ProcedureStepData
    }
  }
  ${fragments.all}
`;

export const procedureStep = gql`
  query ($patientId: Long!, $procedureStepType: ProcedureStepType!) {
    procedureStep(patientId: $patientId, procedureStepType: $procedureStepType) {
      ...ProcedureStepData
    }
  }
  ${fragments.all}
`;

export const setProcedureStepTimestamp = gql`
  mutation setProcedureStepTimestamp(
    $procedureStepId: Long!
    $procedureStepType: ProcedureStepType!
    $patientId: Long!
    $timestamp: DateTime!
  ) {
    setProcedureStepTimestamp(
      procedureStepId: $procedureStepId
      procedureStepType: $procedureStepType
      patientId: $patientId
      timestamp: $timestamp
    )
  }
`;

export const setAnesthesiaEnd = gql`
  mutation setAnesthesiaEnd($patientId: Long!, $timestamp: DateTime!) {
    setAnesthesiaEnd(patientId: $patientId, timestamp: $timestamp)
  }
`;

export const setDirectProcedureStep = gql`
  mutation setDirectProcedureStep(
    $patientId: Long!
    $roomId: Long!
    $procedureStepType: ProcedureStepType!
    $timestamp: DateTime!
    $expectedMeasurementId: Long
  ) {
    setDirectProcedureStep(
      patientId: $patientId
      roomId: $roomId
      procedureStepType: $procedureStepType
      timestamp: $timestamp
      expectedMeasurementId: $expectedMeasurementId
    )
  }
`;

export const setPatientEventTimestamp = gql`
  mutation setPatientEventTimestamp($patientId: Long!, $eventType: Json!, $timestamp: DateTime!) {
    setPatientEventTimestamp(patientId: $patientId, eventType: $eventType, timestamp: $timestamp)
  }
`;

export const clearDirectProcedureStep = gql`
  mutation clearDirectProcedureStep(
    $patientId: Long!
    $roomId: Long!
    $procedureStepType: ProcedureStepType!
    $expectedMeasurementId: Long!
  ) {
    clearDirectProcedureStep(
      patientId: $patientId
      roomId: $roomId
      procedureStepType: $procedureStepType
      expectedMeasurementId: $expectedMeasurementId
    )
  }
`;
